import React, { Component, Fragment } from "react";
import { formatDistance } from "date-fns";
import { withRouter } from "react-router-dom";
import Button from "@mui/material/Button";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import userService from "../../services/userService";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingButton from "@mui/lab/LoadingButton";
import { withSnackbar } from "./../../hocs/withSnackbar";
import postService from "../../services/postService";
import Username from './Username';

function getPostDate(creationDate) {
  return formatDistance(new Date(creationDate), Date.now(), {
    addSuffix: true,
  });
}

class Reply extends Component {
  state = {
    showDeleteButton: false,
    showDeleteConfirmationDialog: false,
    deleteLoading: false,
  };

  deleteReply = async () => {
    this.setState({
      deleteLoading: true,
    });
    const { reply, history } = this.props;
    try {
      const response = await postService.deleteReply(reply.id);
      this.props.onDelete();
      this.setState({
        deleteLoading: false,
        showDeleteConfirmationDialog: false,
      });
    } catch (error) {
      if (error.response) {
        this.props.showMessage(error.response.data.message, "error");
        this.setState({
          deleteLoading: false,
          showDeleteConfirmationDialog: false,
        });
      }
    }
  };

  render() {
    const { reply, history } = this.props;
    const { showDeleteButton, showDeleteConfirmationDialog, deleteLoading } =
      this.state;
    const author = reply.author;
    const currentUser = userService.getCurrentUser();
    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;

    return (
      <Fragment>
        <div
          className="post"
          style={{ display: "flex", position: "relative" }}
          onMouseOver={() => this.setState({ showDeleteButton: true })}
          onMouseOut={() => this.setState({ showDeleteButton: false })}
        >
          <div className="post-profile-pic">
            <div className="pic-container">
              <img src={`${backendApiPath}/profile/${author.username}/pic`} />
            </div>
          </div>
          <div className="post-data">
            <div className="post-metadata">
              <Username
                username={author.username}
                onClick={(e) => {
                  e.preventDefault();
                  history.push(`/profile/${author.username}`);
                }}
              />
              <div className="post-date">{getPostDate(reply.createDate)}</div>
            </div>
            <div className="post-content">
              <p
                className="post-body"
                style={{
                  fontSize: 15,
                  marginTop: 7,
                }}
              >
                {reply.body}
              </p>
            </div>
          </div>
          {(author.username == currentUser.sub || currentUser.isAdmin) &&
            showDeleteButton && (
              <Button
                startIcon={<DeleteOutlineIcon />}
                variant="outlined"
                color="error"
                size="small"
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                }}
                onClick={() => {
                  this.setState({
                    showDeleteConfirmationDialog: true,
                  });
                }}
              >
                Delete
              </Button>
            )}
        </div>
        <Dialog
          open={showDeleteConfirmationDialog}
          onClose={() => {
            this.setState({
              showDeleteConfirmationDialog: false,
            });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontFamily: "inherit",
            }}
          >
            {"Confirm reply deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontFamily: "inherit",
              }}
            >
              Are you sure you want to delete your reply? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={(e) => {
                this.setState({
                  showDeleteConfirmationDialog: false,
                });
              }}
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={this.deleteReply}
              loading={deleteLoading}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              autoFocus
              variant="contained"
              color="error"
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default withRouter(withSnackbar(Reply));
